export default {
  title: 'Belønninger',
  guest: {
    eyebrow: 'Belønninger',
    headline: 'Hver ordre giver dig <highlight>belønninger</highlight>',
    subheading_one: 'Optjen {{count}} point pr. {{amount}} brugt.',
    subheading_other: 'Optjen {{count}} point pr. {{amount}} brugt.',
    cta: 'Tilmeld dig og begynd at optjene',
    already_member: 'Allerede medlem?',
    sign_in: 'Log ind',
    redeemable_heading: 'Dine point = gratis mad',
    redeemable_eyebrow: '🎁 Belønninger, du låser op',
  },
  member: {
    balance_label: 'Din saldo',
    balance_suffix: 'point · værd <highlight>{{amount}}</highlight>',
    next_reward: 'Næste belønning ved <highlight>{{points}} point</highlight>',
    redeem_hint: '✓ Du kan indløse op til {{points}} point ({{amount}}) på din næste ordre',
    expiration_zero: '⏳ {{points}} point udløber i dag',
    expiration_one: '⏳ {{points}} point udløber om 1 dag',
    expiration_other: '⏳ {{points}} point udløber om {{count}} dage',
    pts_lifetime: 'Point i alt',
    saved_lifetime: 'Sparet i alt',
    cta: 'Bestil nu',
    redeemable_heading: 'Det kan du indløse',
    redeemable_eyebrow: 'Du har {{points}} point ({{amount}})',
    redeemable_description:
      'Op til {{maxPoints}} point ({{maxAmount}}) pr. ordre. Varer under {{maxAmount}} er helt gratis.',
  },
  items: {
    free: 'GRATIS',
    save: 'Spar {{amount}}',
  },
  history: {
    eyebrow: 'Historik',
    title: 'Seneste aktivitet',
    load_more: 'Indlæs flere',
    sources: {
      welcome_bonus: 'Velkomstbonus',
      google_review_reward: 'Belønning for Google-anmeldelse',
      reward_loyalty_program_conversion: 'Konvertering af loyalitetsprogram',
      cashback: 'Optjent cashback',
      refund: 'Ordre refunderet',
      cashback_usage: 'Point indløst',
      cashback_usage_refund: 'Indløsning refunderet',
      expired_points_void: 'Point udløbet',
      mobile_app_signup_bonus: 'Tilmeldingsbonus for mobilapp',
    },
    detail_with_order: 'Ordre #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Enkelt og automatisk',
    eyebrow_member: 'Kort påmindelse',
    title: 'Sådan fungerer det',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Tilmeld dig gratis',
        desc: 'Opret en konto på 30 sekunder.',
      },
      order: {
        emoji: '🍔',
        title: 'Bestil og optjen',
        desc_one: '1 point pr. {{amount}} – registreres automatisk.',
        desc_other: '{{count}} point pr. {{amount}} – registreres automatisk.',
      },
      build: {
        emoji: '⭐',
        title: 'Opbyg point',
        desc: 'Indløs fra {{minPoints}} point. Gyldige i {{lifetime}} dage.',
      },
      save: {
        emoji: '🎁',
        title: 'Spar ved checkout',
        desc: 'Op til {{maxAmount}} rabat – anvendes med det samme.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Bestil igen og spar',
        desc: 'Hver ordre øger din saldo.',
      },
    },
  },
  faq: {
    eyebrow: 'Spørgsmål?',
    title: 'Ofte stillede spørgsmål',
    items: {
      earn: {
        q: 'Hvordan optjener jeg point?',
        a_one:
          'Du optjener 1 point for hver {{amount}}, du bruger. Point tilføjes automatisk til din konto efter hver ordre – ingen scanning eller koder nødvendige.',
        a_other:
          'Du optjener {{count}} point for hver {{amount}}, du bruger. Point tilføjes automatisk til din konto efter hver ordre – ingen scanning eller koder nødvendige.',
      },
      redeem: {
        q: 'Hvornår kan jeg begynde at indløse?',
        a: 'Du kan begynde at indløse, når du har nået {{minPoints}} point. Brug dem ved checkout for at reducere din ordresum.',
      },
      max: {
        q: 'Hvor meget kan jeg spare pr. ordre?',
        a: 'Du kan indløse op til {{maxPoints}} point ({{maxAmount}}) pr. ordre. Det er den maksimale rabat, du kan bruge ved én checkout.',
      },
      validity: {
        q: 'Hvor længe er point gyldige?',
        a: 'Point er gyldige i {{lifetime}} dage fra det tidspunkt, de optjenes. Brug dem, før de udløber!',
      },
    },
  },
};
